/**
 * Display-only role renames. The role keys (and the labels stored in
 * role_services) stay unchanged — only what the UI shows is overridden.
 */
export const ROLE_DISPLAY_LABELS = {
  transaction_coordinator: 'Transaction Success Specialist',
};

/** Label to show for a role key, falling back to the given label / the key. */
export function roleDisplayLabel(roleName, fallback) {
  return ROLE_DISPLAY_LABELS[roleName] || fallback || roleName;
}

/**
 * Apply the display renames to a role list from the API. The stored values are
 * kept as db_role_label / db_role_description for code that writes them back.
 */
export function withRoleDisplayLabels(roles = []) {
  return roles.map((role) => {
    const label = ROLE_DISPLAY_LABELS[role.role_name];
    if (!label) return role;
    return {
      ...role,
      db_role_label: role.role_label,
      db_role_description: role.role_description,
      role_label: label,
      // descriptions are used as labels in some dropdowns; rename the role there too
      role_description: (role.role_description || '').replace(/transaction co-?ordinator/gi, label),
    };
  });
}
